module.exports = __webpack_public_path__ + "static/media/img24.fd98e530.jpg";